export default function IsThisForMe() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="flex justify-center mb-8">
          <img 
            src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160517458/settings_images/25ce3bb-c4c5-d20b-dbf3-7e3c564aaf43_0a9554db-dfc8-42b5-bbf2-fe0e7fe8eafe.png" 
            alt="Icon" 
            className="w-16 h-16 bg-gray-900 rounded-lg p-2"
          />
        </div>

        {/* For You Section */}
        <div className="max-w-5xl mx-auto mb-12">
          <div className="bg-gray-900 text-white rounded-lg shadow-lg p-8">
            <h3 className="text-3xl font-bold mb-6">
              <span>Is The AI Creator Course For Me?</span>
            </h3>
            <p className="text-base mb-6">
              <span>We've built this course to be valuable for any stage of your content journey.<br /><br /><strong>This course is for you if:</strong></span>
            </p>
            <ul className="space-y-3 text-base">
              <li className="flex items-start">
                <span className="text-green-400 mr-3 mt-1">✓</span>
                <span>You're planning to launch a YouTube channel, social media presence, personal brand, or business online</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-400 mr-3 mt-1">✓</span>
                <span>You want to grow your audience but feel overwhelmed about where to begin</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-400 mr-3 mt-1">✓</span>
                <span>You're looking to learn the most efficient and optimized strategies to create content with AI</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-400 mr-3 mt-1">✓</span>
                <span>You work in marketing and want to bring fresh, AI-powered ideas to your team</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-400 mr-3 mt-1">✓</span>
                <span>You want to future proof yourself to ensure you always stay on top of emerging AI tools and trends</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Not For You Section */}
        <div className="max-w-5xl mx-auto mb-12">
          <div className="bg-white rounded-lg shadow-lg border-2 border-gray-200 p-8">
            <h4 className="text-2xl font-bold text-gray-900 mb-6">
              <span>You Probably Shouldn't Join If...</span>
            </h4>
            <ul className="space-y-3 text-base text-gray-700">
              <li className="flex items-start">
                <span className="text-red-500 mr-3 mt-1">✗</span>
                <span>You hate the thought of posting youtube content and are fine missing out on the insane brand building potential it holds!</span>
              </li>
              <li className="flex items-start">
                <span className="text-red-500 mr-3 mt-1">✗</span>
                <span>You do not care about SPEED!​ This course was created for people that want to achieve their goals FAST. If you prefer watching hundreds of repetitive videos on youtube and NOT practicing along the way... then this course is not for you.</span>
              </li>
            </ul>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <a 
            href="/checkout" 
            className="inline-block bg-green-600 text-white px-12 py-4 rounded-full text-xl font-bold hover:bg-green-700 transition-all whitespace-nowrap cursor-pointer"
          >
            Get Lifetime Access Today!
          </a>
        </div>
      </div>
    </section>
  );
}
